import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import Membership from '../models/membership';
import Group from '../models/groups';

export enum PermissionsTabEnum {
  Members = 'members',
  Groups = 'groups',
}

export type PermissionsState = {
  tab: PermissionsTabEnum;
  groupsSearch: string;
  selectedGroups: Group[];
  hasTotalGroupsSelected: boolean;
  groupsPage: number;
  groupsPerPage: number;
  membersSearch: string;
  membersRoleFilter: string;
  selectedMembers: Membership[];
  hasTotalMembersSelected: boolean;
  membersPage: number;
  membersPerPage: number;
  memberIDs: string[];
  groupIDs: string[];
  roles: {name: string, id: string}[];
  ownerRoles: string[];
};

export const initialState: PermissionsState = {
  tab: PermissionsTabEnum.Members,
  groupsSearch: '',
  selectedGroups: [],
  hasTotalGroupsSelected: false,
  groupsPage: 1,
  groupsPerPage: 100,
  membersSearch: '',
  membersRoleFilter: '',
  selectedMembers: [],
  hasTotalMembersSelected: false,
  membersPage: 1,
  membersPerPage: 100,
  memberIDs: [],
  groupIDs: [],
  roles: [],
  ownerRoles: [],
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers,
});

export const {
  setSearch,
  toggleAll,
  toggleGroup,
  toggleMember,
  setTab,
  setDefaults,
  setMemberRoleFilter,
  toggleTotal,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
